<template>
    <el-dialog
        title="查看"
        :visible.sync="workMessExamine"
        width="1000px" :close-on-click-modal="false">
        <div class="examine">
            <h2>活动基础信息</h2>
            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap">模板名称:</p>
                    <p>{{ form.templateName }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap">皮肤名称 :</p>
                    <p>{{ form.styleName }}</p>
                </div>
            </div>
            <div class="examineList">
                <p>活动编号 :</p>
                <p>{{ form.code }}</p>
            </div>
            <div class="examineList">
                <p>活动名称 :</p>
                <p>{{ form.activityName }}</p>
            </div>
            <div class="examineList">
                <p>活动封面 :</p>
                <img :src="form.activityLogo" alt=""/>
            </div>
            <div class="examineList">
                <p>活动Banner :</p>
                <img :src="form.bannerUrl" alt=""/>
            </div>
            <div class="examineList" v-show="form.content">
                <p>活动简介 :</p>
                <p v-html="form.content" class="examine_html vHtmlMess"></p>
            </div>
            <div class="examineList" v-show="form.activityUrl">
                <p>宣传图 :</p>
                <img :src="form.activityUrl">
            </div>
            <div class="examineList" v-show="form.activityVideoUrl">
                <p>宣传视频 :</p>
                <div style="width: 480px;height: 270px;">
                    <video-player
                        class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions"
                    ></video-player>
                </div>
            </div>
            <!--<div class="examineList">
                <p>作品征集 :</p>
                <p>{{ timeDate(form.activityCollectStartTime) }}——{{ timeDate(form.activityCollectEndTime) }}</p>
            </div>
            <div class="examineList">
                <p>作品评选 :</p>
                <p>{{ timeDate(form.activityChooseStartTime) }}——{{ timeDate(form.activityChooseEndTime) }}</p>
            </div>
            <div class="examineList">
                <p>作品公示 :</p>
                <p>{{ timeDate(form.activityShowStartDate) }}</p>
            </div>
            <div class="examineList" v-show="typeList.length > 0">
                <p>作品类别 :</p>
                <p v-for="(item,index) in typeList" :key="index">{{ item.worksType }}</p>
            </div>-->
        </div>
        <div class="examine">
            <h2>节点信息</h2>
            <div class="examineList" v-show="nodeList.length > 0">
                <p>节点信息 :</p>
                <el-table
                    border
                    :data="nodeList"
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="节点名称">
                    </el-table-column>
                    <el-table-column
                        prop="startDate"
                        label="开始时间">
                    </el-table-column>
                    <el-table-column
                        prop="endDate"
                        label="结束时间">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="节点状态">
                        <template slot-scope="scope">
                            {{ showStatusInfo(scope.row.status) }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="examine">
            <h2>评分规则</h2>
            <div class="examineList">
                <p>投票次数 :</p>
                <p>{{ form.voteNum }}</p>
            </div>
            <div class="examineList">
                <p>投票时间 :</p>
                <p>{{ timeDate(form.activityVoteStartDate) }}——{{ timeDate(form.activityVoteEndDate) }}</p>
            </div>
        </div>
        <div class="examine">
            <h2>赛道规则</h2>
            <div class="examineList" v-show="wayList.length > 0">
                <p>赛道规则 :</p>
                <el-table
                    border
                    :data="wayList"
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="赛道名称">
                    </el-table-column>
                    <el-table-column
                        prop="voteRatio"
                        label="投票占比">
                    </el-table-column>
                    <el-table-column
                        prop="judgesAppraisalRatio"
                        label="评委评分占比">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button  type="text" size="small" @click="viewWayInfo(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="examine">
            <h2>活动详情</h2>
            <div class="examineList_newBox">
                <!--<div class="examineListTwo_box">
                    <p style="white-space:nowrap">主办方 :</p>
                    <p>{{ form.sponsorName }}</p>
                </div>-->
                <div class="examineListTwo_box2"
                     v-for="(item,index) in organizationList"
                     :key="index"
                     v-show="organizationList.length > 0">
                    <p style="white-space:nowrap;">{{ item.organizationName }} :</p>
                    <p style="margin-left: 22px;">{{ item.organizationContent }}</p>
                </div>
            </div>
            <!--<div class="examineList examineListTwo">
                <div class="examineListTwo_box" v-show="form.undertakerName">
                    <p style="white-space:nowrap">承办方 :</p>
                    <p>{{ form.undertakerName }}</p>
                </div>
                <div class="examineListTwo_box" v-show="form.jointlyName">
                    <p style="white-space:nowrap">协办方 :</p>
                    <p>{{ form.jointlyName }}</p>
                </div>
            </div>-->
            <div class="examineList" v-show="logoList.length > 0">
                <p>合作方 :</p>
                <div class="logoImg">
                  <img v-for="(item,index) in logoList" :key="index" :src="item.url"/>
                </div>
            </div>
            <div class="examineList" v-show="form.entryDemand">
                <p>参赛需求 :</p>
                <p v-html="form.entryDemand" class="examine_html vHtmlMess"></p>
            </div>
            <div class="examineList" v-show="form.entryRule">
                <p>参赛规则 :</p>
                <p v-html="form.entryRule" class="examine_html vHtmlMess"></p>
            </div>
            <div class="examineList" v-show="form.fileContent">
                <p>相关资料 :</p>
                <p v-html="form.fileContent" class="examine_html vHtmlMess"></p>
            </div>
             <div class="examineList" v-if="fileList.length>0">
                <p style="white-space:nowrap">附&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;件 :</p>
                <p style="color: #1890FF;cursor: pointer;"
                   v-for="(item,index) in fileList" :key="index"
                   @click="downloadFile(item.url)">{{ item.name }}</p>
            </div>
            <div class="examineList">
                <p>参赛指南 :</p>
                <p v-html="form.entryGuide" class="examine_html vHtmlMess"></p>
            </div>
        </div>
        <way-details-dialog ref="wayDetailDialogRefs"></way-details-dialog>
    </el-dialog>
</template>

<script>
import { getActivityDetail } from '../../../utils/interface';
import wayDetailsDialog from './wayDetailsDialog';
export default {
    name: "viewDialog",
    data() {
        return{
            type:"",
            workMessExamine: false,
            form:{},
            fileList:[],
            logoList:[],
            nodeList:[],
            wayList:[],
            organizationList:[],
            playerOptions : {
                // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: true, // 默认情况下将会消除任何音频。
                loop: true, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                    src: "" //url地址
                }],
                poster: "", //你的封面地址
                // width: document.documentElement.clientWidth, //播放器宽度
                // notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: false,
                    durationDisplay: false,
                    remainingTimeDisplay: false,
                    fullscreenToggle: false  //全屏按钮
                },
            },
        }
    },
    components:{
        wayDetailsDialog
    },
    methods: {
        showStatusInfo(result){
            if(result === "PREPARE"){
                return "准备中";
            }else if(result === "COLLECT"){
                return "征集中";
            }else if(result === "EVALUATE"){
                return "评选中";
            }else if(result === "FINISHED"){
                return "已结束";
            }
        },
        viewWayInfo(item){
            this.$refs.wayDetailDialogRefs.init(item);
        },
        init(type,uuid) {
            this.type = type;
            getActivityDetail(uuid).then((res)=>{
                this.form = res;
                this.fileList = res.fileList;
                this.logoList = res.logoList;
                this.nodeList = res.nodeList;
                this.wayList = res.wayList;
                this.organizationList = res.organizationList;
                if(res.activityVideoUrl!=''){
                    this.playerOptions.sources[0].src = res.activityVideoUrl;
                }
                this.workMessExamine = true;
            });
        },
        downloadFile(fileUrl){
            let a = document.createElement('a');
            a.href = fileUrl;
            a.click();
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        }
    }
}
</script>

<style scoped lang="less">
    /deep/.el-dialog__body {
        padding-top: 0;
    }
    .examine {
        h2 {
            font-weight: 700;
            font-size: 16px;
            color: #000;
            margin-top: 26px;
            letter-spacing: 1px;
            border-top: 1px solid #efefef;
            padding-top: 16px;
        }
        &:nth-of-type(1) h2{
          border-top: none;
          padding-top: 0;
        }
        .examineList {
            display: flex;
            // align-items: center;
            img {
                width: 300px;
                height: 150px;
            }
            p:nth-of-type(1){
                margin-right: 16px;
                width: 85px;
                flex-shrink: 0;
            }
            .examine_html {
              /deep/p {
                margin: 0;
              }
              /deep/img {
                max-width: 100%;
              }
            }
            .logoImg {
              display: flex;
              flex-wrap: wrap;
              img {
                margin-right: 10px;
                margin-bottom: 10px;
                width: 190px;
                height: 90px;
              }
            }
            margin-top: 2px;
        }
        .examineListTwo {
            display: flex;
            align-items: center;
            .examineListTwo_box {
                display: flex;
                align-items: center;
                width: 50%;
            }

        }
        .examineList_newBox {
            .examineListTwo_box2 {
                display: flex;
            }
        }

    }
    .audit {
        padding-bottom: 20px;
        h3 {
            font-weight: 700;
            font-size: 16px;
            color: #000;
            margin-top: 26px;
            letter-spacing: 1px;
            // border-bottom: 1px solid #ddd;
            padding-bottom: 15px;
        }
        .auditContent {
            // padding: 0 30px;
        }
        .cause {
            display: flex;
            margin-top: 20px;
            .causeTitle {
                min-width: 80px;
                color: #3a8ee6;
            }
            .causeContent {
                color: #000;
            }
        }
        .auditEnter {
            text-align: center;
            padding-top: 20px;
            button {
                width: 120px;
            }
        }
    }
    /deep/img {
        max-width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/viewDialog.vue